import { FireTestingStatus, QualityControlStatus } from '@/types/batch-types'

export const getStatusText = (status: string | number, isQualityCheck = true) => {
  if (typeof status === 'number') {
    if (isQualityCheck) {
      switch (status) {
        case QualityControlStatus.PENDING:
          return 'Pending'
        case QualityControlStatus.PASSED:
          return 'Passed'
        case QualityControlStatus.QUARANTINE:
          return 'Quarantine'
        default:
          return 'Pending'
      }
    } else {
      switch (status) {
        case FireTestingStatus.PENDING:
          return 'Pending'
        case FireTestingStatus.PASSED:
          return 'Passed'
        case FireTestingStatus.FAILED:
          return 'Failed'
        default:
          return 'Pending'
      }
    }
  }
  return status
}